var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlBody3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 704,
    viewBox: "0 0 618 704",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Body / 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.004 339.382L198.184 339.18C198.184 339.18 198.204 338.962 198.222 338.502C202.982 338.84 207.584 339.12 212.004 339.382Z",
    fill: "#C83820"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sweater color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sweater",
    d: "M493.604 489.141L447.982 494.859L374.504 379.939L371.822 341.741L259.884 340.081L212.104 339.381H212.004C207.584 339.119 202.982 338.841 198.224 338.501C138.044 334.301 54.6637 322.599 48.9437 290.199C38.5637 231.519 117.084 117.641 126.364 104.441C126.944 103.621 127.242 103.181 127.242 103.181C140.402 84.3815 153.644 69.7615 166.004 61.9815C190.044 46.8415 212.584 43.5195 234.004 43.5815L239.742 2.00146L327.124 14.0595L322.364 48.6215C348.024 51.0815 365.482 56.0995 381.822 71.0995C434.284 119.261 438.144 299.641 438.144 299.641L493.604 489.141Z",
    fill: "#CE3D29"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.883 340.081V340.881C259.883 340.881 239.843 340.921 212.103 339.381L259.883 340.081Z",
    fill: "#C83820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    opacity: 0.201149,
    d: "M370.215 341.278C376.631 259.792 421.041 242.562 389.041 151.176",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.768 442.087L278.892 422.853C273.426 422.221 269.828 416.849 271.326 411.557L337.262 178.601C338.454 174.391 342.522 171.667 346.87 172.167L513.746 191.401C519.21 192.031 522.81 197.405 521.31 202.697L455.376 435.651C454.184 439.863 450.114 442.587 445.768 442.087Z",
    fill: "#18181C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iPad",
    d: "M297.583 355.031C297.9 355.116 298.221 355.203 298.546 355.295C310.14 358.459 321.99 360.373 338.472 358.201C349.074 356.815 358.188 355.003 358.086 353.311C357.794 349.037 352.648 348.079 352.648 348.079L342.748 348.557L333.224 347.993C333.224 347.993 376.98 339.717 376.98 338.435C376.844 333.921 369.662 332.091 369.662 332.091C369.662 332.091 384.708 329.697 384.536 327.303C384.126 321.217 377.408 320.755 377.408 320.755C377.408 320.755 379.272 319.147 379.084 317.659C378.348 311.657 367.644 310.665 362.548 309.931C362.548 309.931 345.21 309.693 340.046 308.409C326.465 305.018 318.382 301.989 313.311 299.459L347.195 179.745C348.387 175.535 352.457 172.811 356.803 173.311L523.679 192.547C529.143 193.175 532.743 198.549 531.243 203.841L465.309 436.795C464.117 441.007 460.049 443.731 455.701 443.231L288.825 423.997C283.361 423.365 279.761 417.993 281.259 412.701L297.583 355.031Z",
    fill: "#FCBDA4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.98 338.435C376.844 333.921 369.662 332.091 369.662 332.091C369.662 332.091 384.708 329.697 384.536 327.303C384.126 321.217 377.408 320.755 377.408 320.755C377.408 320.755 379.272 319.147 379.084 317.659C378.403 312.1 369.172 310.839 363.763 310.1C363.332 310.041 362.925 309.985 362.548 309.931C362.548 309.931 345.21 309.693 340.046 308.409C314.294 301.979 308.31 296.851 305.148 293.961C305.051 293.873 304.958 293.787 304.867 293.703C304.605 293.462 304.364 293.241 304.12 293.039C304.298 292.846 304.5 292.525 304.711 292.189C305.007 291.716 305.322 291.214 305.612 291.005L310.012 274.879C306.79 275.227 303.641 275.336 300.521 275.444C296.141 275.595 291.818 275.745 287.434 276.553C275.48 278.759 268.402 281.531 268.402 281.531L253.15 286.745L242.088 327.679C246.276 331.407 256.312 338.759 263.12 342.469C276.264 349.628 282.053 351.085 290.937 353.32C292.429 353.695 294.009 354.093 295.726 354.543C295.921 354.594 296.117 354.645 296.315 354.697C297.038 354.886 297.781 355.08 298.546 355.295C310.14 358.459 321.99 360.373 338.472 358.201C349.074 356.815 358.188 355.003 358.086 353.311C357.794 349.037 352.648 348.079 352.648 348.079L342.748 348.557L333.224 347.993C333.224 347.993 376.98 339.717 376.98 338.435ZM517.931 520.581C516.07 516.927 503.298 501.584 492.811 489.241L449.144 494.714C444.144 524.205 464.919 566.353 464.919 566.353C464.919 566.353 454.113 559.761 451.963 565.525C451.005 568.093 448.837 588.587 489.317 589.967C493.615 590.115 503.953 581.373 503.953 581.373C503.953 581.373 496.415 595.767 507.957 598.595C507.957 598.595 526.561 570.721 526.845 564.521C527.129 558.317 521.159 526.923 517.931 520.581Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    opacity: 0.148065,
    d: "M473.184 510.103C473.184 510.103 478.864 531.561 498.358 538.247C505.176 540.585 503.474 568.185 520.18 564.885",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.151 195.014C362.837 199.142 360.033 201.936 357.887 201.254C355.741 200.572 355.067 196.67 356.381 192.542C357.695 188.412 360.499 185.618 362.645 186.3C364.791 186.984 365.465 190.884 364.151 195.014Z",
    fill: "#020101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    opacity: 0.200498,
    d: "M196.059 167.334L153.939 237.078L258.665 278.516",
    stroke: "black",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlBody3);
export default __webpack_public_path__ + "static/media/Girl-Body-3.b8216a7d.svg";
export { ForwardRef as ReactComponent };